import { create } from "zustand";
import { toastError } from "../../Helpers/toasts";
import CommonRepository from "../../Repositories/Config/CommonRepository";
import MainGroupsRepository from "../../Repositories/Groups/MainGroupsRepository";
import AgeGroupReportRepository from "../../Repositories/Reports/AgeGroupReportRepository";

export const useAgeGroupReportStore = create((set) => ({
  results: null,
  reasoning: null,
  branches: null,
  subjects: null,
  isLoading: false,
  queryParams: {
    page: 1,
  },

  setLoading: (status) => {
    set({
      isLoading: status,
    });
  },

  updateParams: (paramItem) => {
    set((prevState) => ({
      queryParams: { ...prevState.queryParams, ...paramItem },
    }));
  },
  getBranches: async () => {
    const { data, status } = await MainGroupsRepository.getAllBranches()
    if (status) {
      set({
        branches: data,
      })
    }
  },
  getSubjects: async () => {
    const { data, status } = await CommonRepository.getSubjects()
    if (status) {
      set({
        subjects: data,
      })
    }
  },
  onReload: async (queryString) => {
    const { data, status, nonFieldErrors } =
      await AgeGroupReportRepository.studentsList(queryString);
    if (status) {
      set({
        results: data.lesson_months,
        ageGroupsList: data.age_groups_list,
        teachersList: data.teachers_list,
        totalСounts: data.total_counts,
        queryParams: { page: 1 },
      });
    } else toastError(nonFieldErrors);
  },

  loadItems: async (queryString) => {
    const { data, status, nonFieldErrors } =
      await AgeGroupReportRepository.studentsList(queryString);
    if (status) {
      set({
        results: data.lesson_months,
        totalСounts: data.total_counts,
      });
    } else toastError(nonFieldErrors);
  },
}));
